import BuyButton from '@components/BuyButton';
import { preparePriceFloatObject } from '@utils/floatNumbers';
import { Link } from '@compat/router';
import type { FC } from 'react';
import type { HeaderSearchSettings } from '../..';
import { Picture } from '@ui';
import icons from '@icons';
import './index.scss';

const {
  star: { midYellow: starYellowFilled }
} = icons.Fill;

interface SearchItemProps {
  item: NonNullable<HeaderSearchSettings['searchData']>['products'][number];
}

const SearchItem: FC<SearchItemProps> = ({ item }) => {
  const {
    link_url,
    image_url,
    rating,
    commentNumber,
    name,
    price,
    id,
    available,
    isDigital
  } = item;

  const priceFloat = price
    ? preparePriceFloatObject(price?.replace(/\.0+$/, ''))
    : null;

  if (!id) {
    return null;
  }

  return (
    <div className={`SearchItem`}>
      <Link className='SearchItem__wrapper' to={`${link_url}`}>
        <div className='SearchItem__img-wrap'>
          <img className='SearchItem__img' src={image_url || ''} alt={name} />
        </div>
        <div className='SearchItem__info'>
          <div className='SearchItem__name'>{name}</div>
          <div className='SearchItem__info-wrap'>
            <div className='SearchItem__rating'>
              <Picture icon={starYellowFilled} height={16} width={16} />
              <div className='SearchItem__rating-text'>
                {rating}{' '}
                <span className='SearchItem__rating-count'>
                  ({commentNumber})
                </span>
              </div>
            </div>
            <div className='SearchItem__price'>
              {priceFloat?.wholePart}
              {priceFloat?.floatPart && (
                <span className='SearchItem__price__decimal'>
                  ,{priceFloat?.floatPart}
                </span>
              )}{' '}
              <span className='SearchItem__price__ruble'>₽</span>
            </div>
          </div>
        </div>
      </Link>

      <BuyButton
        canBeBought
        className='buy-btn SearchItem__buy-btn'
        productId={Number(id)}
        available={available}
        isDigital={isDigital}
      />
    </div>
  );
};

export default SearchItem;
